module.exports = __webpack_public_path__ + "static/media/SCHAALKLEURSTOF_04.6eab6724.png";